import {
  SET_CONVERSATION_ID_AI,
  SET_INITIAL_MESSAGE_AI,
  UPDATE_AI,
} from '../actions/types';

const initialState = {
  aiMasterMap: undefined,
  conversationId: null,
  initialMessage: null,
};

const aiReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_AI:
      return { ...state, ...action.payload };

    case SET_CONVERSATION_ID_AI:
      return { ...state, conversationId: action.payload };

    case SET_INITIAL_MESSAGE_AI:
      return { ...state, initialMessage: action.payload };

    default:
      return state;
  }
};

export default aiReducer;
